import { BsFillTrashFill } from "react-icons/bs";
import CustomButton from "shared/components/button/CustomButton";
import ModalExcluirDespesaGroupPay from "./ModalExcluirDespesaGroupPay";
import { useEffect, useState } from "react";
import { BuscarDespesaGroupPayResponse } from "types/response/groupPay/BuscarDespesaGroupPayResponse";
import { DespesaGroupPayAgrupadaResponse } from "types/response/groupPay/DespesaGroupPayAgrupadaResponse";
import {
  formatarDataString,
  formatarLocalDateTime,
  formatarValorMonetario,
} from "shared/util/functions/formatacoesDeValores/FormatarValores";
import { formatarCpfOuCnpjEmissorParaExibicao, rotuloCpfOuCnpj } from "shared/util/formatters/cnpj";
import useItemListaDespesaGroupPayStyles from "./styles/ItemListaDespesaGroupPayStyles";
import { Grid, IconButton, Menu, MenuItem } from "@material-ui/core";
import { RiMoreFill } from "react-icons/ri";
import { FaArrowCircleDown, FaPlus } from "react-icons/fa";
import clsx from "clsx";
import ModalVincularDespesaGroupPay from "../detalheDespesaGroupPay/ModalVincularDespesaGroupPay";
import { useGetDownloadDocumentoDespesaGroupPay } from "hooks/groupPay/useGetDownloadDocumentoDespesaGroupPay";
import ModalCadastrarDespesaUnicaGroupPay from "../detalheDespesaGroupPay/ModalCadastrarDespesaUnicaGroupPay";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";
import { useGetDespesaGroupPayDetalhada } from "hooks/groupPay/useGetDespesaGroupPayDetalhada";
import ModalCadastrarDespesaParceladaGroupPay from "../detalheDespesaGroupPay/ModalCadastrarDespesaParceladaGroupPay";
import ModalInformarParcelasGroupPay, {
  DadosParcelamento,
} from "../detalheDespesaGroupPay/ModalInformarParcelasGroupPay";
import { FaRepeat } from "react-icons/fa6";
import showAlert from "shared/util/functions/alert/showAlert";
import { useRestaurarDespesaGroupPay } from "hooks/groupPay/useRestaurarDespesaGroupPay";
import { useGetDetectarParcelamentoDespesaGroupPay } from "hooks/groupPay/useGetDetectarParcelamentoDespesaGroupPay";
import { usePostCalcularValoresDespesaParcelada } from "hooks/contasPagar/usePostCalcularValoresDespesaParcelada";
import { ValoresDespesaParceladaRequest } from "types/request/contasPagar/ValoresDespesaParceladaRequest";
import { formatarTipoDocumentoDespesaGroupPay } from "constants/EnumTipoNotaFiscalGroupPay";

interface ItemListaDespesaGroupPayProps {
  despesa: BuscarDespesaGroupPayResponse | DespesaGroupPayAgrupadaResponse;
  isHistorico: boolean;
}

type FooterProps = {
  anchorEl: HTMLElement | null;
  openOption: boolean;
  handleOpenOption: (event: React.MouseEvent<HTMLElement>) => void;
  handleClose: () => void;
};

const ItemListaDespesaGroupPay: React.FC<ItemListaDespesaGroupPayProps> = (props) => {
  const [showModalExcluirDespesa, setShowModalExcluirDespesa] = useState(false);
  const [showModalVincularDespesa, setShowModalVincularDespesa] = useState(false);
  const [showModalCadastrarDespesa, setShowModalCadastrarDespesa] = useState(false);
  const [showModalCadastrarDespesaParcelada, setShowModalCadastrarDespesaParcelada] = useState(false);

  const [isFluxoVinculoAutomaticoDespesa, setIsFluxoVinculoAutomaticoDespesa] = useState(false);
  const [despesaDetalhada, setDespesaDetalhada] = useState<DespesaGroupPayDetalhada | null>(null);
  const [showModalInformarParcelas, setShowModalInformarParcelas] = useState(false);
  const [dadosParcelamento, setDadosParcelamento] = useState<DadosParcelamento | null>(null);

  const { despesa, isHistorico } = props;

  const despesaPendenteProcessamento = !despesa?.excluida;


  const isDespesaAgrupada = "isAgrupada" in despesa && despesa.isAgrupada;
  const despesaAgrupada = isDespesaAgrupada ? (despesa as DespesaGroupPayAgrupadaResponse) : null;

  const tipoDocumento = despesa?.origemDespesa === "NOTA_FISCAL" 
    ? "NF" 
    : despesa?.origemDespesa === "BOLETO" 
    ? "BOLETO" 
    : "EMAIL";
  const dataFormatadaAAAAMMDD = (data: string | null | undefined) => {
    if (!data) return "sem-data";
    return data?.replaceAll("-", "");
  }
  const nomeParaArquivo = (texto: string | null | undefined) => {
    if (!texto) return "sem-nome";

    return texto
      .trim()
      .replace(/&/g, 'E')
      .replace(/\s+/g, '_')
      .replace(/[^a-zA-Z0-9._-]/g, '');
  };
  const dataEmissaoOuVencimento = dataFormatadaAAAAMMDD(despesa?.dataEmissao || despesa?.dataVencimento);
  const fornecedorArquivo = nomeParaArquivo(despesa?.nomeEmissor);
  const condominioArquivo = nomeParaArquivo(despesa?.nomeCondominio);

  const fileNameDespesa = `${tipoDocumento}_${despesa?.numeroDoc || "sem-numero"}_${dataEmissaoOuVencimento}_${fornecedorArquivo}_${condominioArquivo}.pdf`

  const idDespesaParaBuscar = isDespesaAgrupada && despesaAgrupada
    ? despesaAgrupada.despesasOriginais[0].id 
    : despesa.id;

  const [deveBuscarDespesaDetalhada, setDeveBuscarDespesaDetalhada] = useState(false);

  const { data: despesaDetalhadaResponse } = useGetDespesaGroupPayDetalhada({
    idDespesaGroupPay: idDespesaParaBuscar.toString(),
    condominioId: despesa.condominioId ? Number(despesa.condominioId) : null,
    deveBuscar: showModalCadastrarDespesa || showModalInformarParcelas || showModalCadastrarDespesaParcelada || deveBuscarDespesaDetalhada,
  });

  const { mutateAsync: restaurarDespesa } = useRestaurarDespesaGroupPay(despesa.id)
  const { mutateAsync: calcularValoresParcelas } = usePostCalcularValoresDespesaParcelada();

  const { data: isParcelada, isLoading: isLoadingParcelamento } = useGetDetectarParcelamentoDespesaGroupPay({
    idDespesaGroupPay: despesa.id,
    condominioId: Number(despesa.condominioId),
    deveBuscar: (!isDespesaAgrupada && (showModalCadastrarDespesa || showModalInformarParcelas || showModalCadastrarDespesaParcelada)),
  });

  useEffect(() => {
    if (showModalCadastrarDespesa || showModalInformarParcelas || showModalCadastrarDespesaParcelada || deveBuscarDespesaDetalhada) {
      if (despesaDetalhadaResponse?.payload) {
        const despesaCondominio = {
          ...despesaDetalhadaResponse.payload,
          idCondominio: Number(despesa.condominioId),
          nomeCondominio: despesa.nomeCondominio,
        };
        setDespesaDetalhada(despesaCondominio || null);
      }
    }
  }, [
    showModalCadastrarDespesa,
    showModalInformarParcelas,
    showModalCadastrarDespesaParcelada,
    deveBuscarDespesaDetalhada,
    despesaDetalhadaResponse,
  ]);

  const { refetch: baixarDocumentoDespesa } = useGetDownloadDocumentoDespesaGroupPay({
    uuidDespesaNoGroupPay: despesa?.uuidDespesaNoGroupPay,
    origemDespesa: despesa?.origemDespesa,
    fileName: fileNameDespesa
  });

  const styles = useItemListaDespesaGroupPayStyles();

  const formatTipoDespesa = (tipoDespesa?: string) => {
    switch (tipoDespesa) {
      case "NOTA_FISCAL":
        return (
          <Grid item xs={2} className={clsx(styles.tipoDespesaIA, styles.sessaoTipoDespesa)}>
            <span>{`IA`}</span>
          </Grid>
        );
      case "BOLETO":
        return (
          <Grid item xs={2} className={clsx([styles.tipoDespesaEmail, styles.sessaoTipoDespesa])}>
            <span>{`E-mail`}</span>
          </Grid>
        );
      case "MAIL_READER":
        return (
          <Grid item xs={2} className={clsx([styles.tipoDespesaEmail, styles.sessaoTipoDespesa])}>
            <span>{`E-mail`}</span>
          </Grid>
        );
      default:
        return "-";
    }
  };

  // As parcelas do carnê vêm da própria despesa: o Group Pay grava uma despesa com N
  // instrumentos de cobrança, e o vencimento e a quantidade já estão lidos do documento. Só a
  // despesa agrupada — nota fiscal parcelada, que chega como N despesas irmãs — precisa das
  // outras linhas para saber disso.
  const parcelasDoCarne = despesaDetalhada?.parcelas ?? [];
  const ehCarneParcelado = !isDespesaAgrupada && parcelasDoCarne.length > 1;

  const numeroParcelasPadrao = isDespesaAgrupada && despesaAgrupada
    ? despesaAgrupada.quantidadeDespesas
    : ehCarneParcelado
      ? parcelasDoCarne.length
      : undefined;

  const handleAbrirCadastroParcelada = (dados: DadosParcelamento) => {
    let parcelasCalculadas = dados.parcelas;
    if (ehCarneParcelado && parcelasDoCarne.length > 0) {
      parcelasCalculadas = dados.parcelas.map((parcela, index) => {
        const parcelaCarne = parcelasDoCarne[index];
        if (!parcelaCarne) {
          return parcela;
        }
        return {
          ...parcela,
          codigoDeBarras:
            parcelaCarne.codigoDeBarras ?? parcelaCarne.linhaDigitavel ?? parcela.codigoDeBarras,
          dataVencimento: parcelaCarne.dataVencimento
            ? new Date(parcelaCarne.dataVencimento)
            : parcela.dataVencimento,
          valorParcela: parcelaCarne.valor ?? parcela.valorParcela,
        };
      });
    }
    setDadosParcelamento({ ...dados, parcelas: parcelasCalculadas });
    setShowModalInformarParcelas(false);
    setShowModalCadastrarDespesaParcelada(true);
  };

  const handleRestaurarDespesa = () => {
    showAlert({
      texto: "A despesa excluída será restaurada e voltará a aparecer na lista de despesas identificadas pela IA. Deseja realmente restaurá-la?",
      tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
      labelBotaoCancelar: "Cancelar",
      onConfirm: async () => {
        await restaurarDespesa(despesa.id);
      },
    });
  }

  const SessaoCondominio = () => {
    return (
      <Grid item xs={8} className={styles.headerTipoENome}>
        {formatTipoDespesa(despesa?.origemDespesa)}
        <div className={styles.sessaoNomeCondominio}>
          <span>{`Condomínio: ${despesa?.nomeCondominio}`}</span>
        </div>
      </Grid>
    );
  };

  const handleCadastrarDespesa = async () => {
    if (isDespesaAgrupada && despesaAgrupada) {
      const numeroParcelas = despesaAgrupada.quantidadeDespesas;
      const valorTotal = despesaAgrupada.valor;
      const primeiraDespesa = despesaAgrupada.despesasOriginais[0];
      const dataVencimentoPrimeiraParcela =
        primeiraDespesa.dataVencimento != null
          ? new Date(primeiraDespesa.dataVencimento)
          : primeiraDespesa.dataEmissao
            ? new Date(primeiraDespesa.dataEmissao)
            : new Date();

      setDeveBuscarDespesaDetalhada(true);

      try {
        const request: ValoresDespesaParceladaRequest = {
          valorTotal: valorTotal,
          numeroDeParcelas: numeroParcelas,
          dataVencimentoPrimeiraParcela: dataVencimentoPrimeiraParcela,
        };

        const response = await calcularValoresParcelas(request);
        setDadosParcelamento({
          parcelas: response.payload,
          valorTotal: valorTotal,
        });
        setShowModalCadastrarDespesaParcelada(true);
      } catch (error) {
        console.error("Erro ao calcular valores das parcelas:", error);
      }
    } else if (isParcelada) {
      setShowModalInformarParcelas(true);
    } else {
      setShowModalCadastrarDespesa(true);
    }
  };

  const renderBotaoCadastrarDespesa = () => {
    return (
      <CustomButton
        id="cadastrar-despesa-automatico"
        label={isDespesaAgrupada ? "Cadastrar despesa" : (isLoadingParcelamento ? "Verificando..." : "Cadastrar despesa")}
        size="sm"
        variant="primary"
        disabled={!isDespesaAgrupada && isLoadingParcelamento}
        onClick={handleCadastrarDespesa}
      />
    );
  };

  const SessaoBotoes = () => {
    return (
      <Grid item xs={4} className={styles.sessaoBotoes}>
        {despesaPendenteProcessamento ? (
          <>
            <CustomButton
              id="vincularDespesa"
              label="Vincular despesa"
              size="sm"
              variant="outline-primary"
              onClick={() => {
                setShowModalVincularDespesa(true);
              }}
            />
            {renderBotaoCadastrarDespesa()}
          </>
        ) : (
          isHistorico && <span className={styles.labelDespesaExluida}> Despesa excluída</span>
        )}
      </Grid>
    );
  };

  const SessaoInformacoes = () => {
    const cpfCnpj = despesa?.cpfCnpjEmissor?.trim();
    const labelCpfCnpj = cpfCnpj ? rotuloCpfOuCnpj(cpfCnpj) : "CPF/CNPJ";
    const documentoParaExibir = cpfCnpj ? formatarCpfOuCnpjEmissorParaExibicao(cpfCnpj) : "-";
    return (
      <>
        <Grid item xs={12} className={styles.linhaInf}>
          <Grid item xs={6} className={styles.camposInf}>
            <span className={styles.labels}>Fornecedor</span>
            <span className={styles.textoDestaque}>{`${despesa?.nomeEmissor}`}</span>
          </Grid>
          <Grid item xs={6} className={styles.camposInf}>
            <span className={styles.labels}>{labelCpfCnpj}</span>
            <span className={styles.textoDestaque}>{documentoParaExibir}</span>
          </Grid>
        </Grid>
        <Grid item xs={12} className={styles.linhaInf}>
          <Grid item xs={3} className={styles.camposInf}>
            <span className={styles.labels}>{isDespesaAgrupada ? "Valor total" : "Valor"}</span>
            <span className={styles.textoDestaque}>
              {despesa?.valor != null ? `R$ ${formatarValorMonetario(despesa.valor)}` : "-"}
            </span>
          </Grid>
          <Grid item xs={3} className={styles.camposInf}>
            <span className={styles.labels}>Data de vencimento</span>
            <span className={styles.textoDestaque}>{despesa?.dataVencimento ? formatarDataString(despesa.dataVencimento) : "-"}</span>
          </Grid>
          <Grid item xs={2} className={styles.camposInf}>
            <span className={styles.labels}>Data de emissão</span>
            <span className={styles.textoDestaque}>{despesa?.dataEmissao ? formatarDataString(despesa.dataEmissao) : "-"}</span>
          </Grid>
          <Grid item xs={2} className={styles.camposInf}>
            <span className={styles.labels}>Tipo de nota</span>
            <div>
              <span className={styles.campoTipoNota}>{formatarTipoDocumentoDespesaGroupPay(despesa?.tipoNotaFiscal, despesa?.origemDespesa)}</span>
            </div>
          </Grid>
          <Grid item xs={2} className={styles.camposInf}>
            <span className={styles.labels}>Número do documento</span>
            <span className={styles.textoDestaque}>{despesa?.numeroDoc ?? "-"}</span>
          </Grid>
        </Grid>
      </>
    );
  };

  const Footer = ({ anchorEl, openOption, handleOpenOption, handleClose }: FooterProps) => {
    return (
      <Grid item xs={12} className={styles.linhaInf} justifyContent="space-between">
        <Grid item>
          <span className={styles.labels}>{`Despesa captada dia ${formatarLocalDateTime(despesa?.dataSincronizacao)}`}</span>
        </Grid>
        <Grid item>
          <IconButton onClick={handleOpenOption} size="small">
            <RiMoreFill />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={openOption}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
            transformOrigin={{
              vertical: -35,
              horizontal: "center",
            }}
          >
            <MenuItem onClick={() => baixarDocumentoDespesa()}>
              <span className={styles.labels}>
                <FaArrowCircleDown style={{ marginRight: 5 }} size={15} />
                Download da despesa
              </span>
            </MenuItem>
            {despesaPendenteProcessamento && (
              <MenuItem onClick={() => setShowModalExcluirDespesa(true)}>
                <span className={styles.labels}>
                  <BsFillTrashFill style={{ marginRight: 5 }} size={15} />
                  Excluir
                </span>
              </MenuItem>
            )}
            {isHistorico && despesa?.excluida && (
              <MenuItem onClick={handleRestaurarDespesa}>
                <span className={styles.labels}>
                  <FaRepeat style={{ marginRight: 5 }} size={15} />
                  Restaurar despesa
                </span>
              </MenuItem>
            )}
          </Menu>
        </Grid>
      </Grid>
    );
  };

  const ItemDespesa = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const openOption = Boolean(anchorEl);

    const handleOpenOption = (e: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <>
        <Grid container className={styles.containerItemDespesa}>
          <SessaoCondominio />
          <SessaoBotoes />
          <SessaoInformacoes />
          <Footer
            anchorEl={anchorEl}
            openOption={openOption}
            handleOpenOption={handleOpenOption}
            handleClose={handleClose}
          />
        </Grid>
      </>
    );
  };

  return (
    <>
      <ItemDespesa />
      <ModalExcluirDespesaGroupPay
        cpfCnpjEmissor={despesa.cpfCnpjEmissor}
        showModal={showModalExcluirDespesa}
        despesaId={despesa.id}
        onCloseModal={() => setShowModalExcluirDespesa(!showModalExcluirDespesa)}
        nomeFornecedor={despesa.nomeEmissor}
      />

      {despesa && (
        <ModalVincularDespesaGroupPay
          despesaGroupPaySelecionada={despesa}
          showModal={showModalVincularDespesa}
          onCloseModal={() => {
            setIsFluxoVinculoAutomaticoDespesa(false);
            setShowModalVincularDespesa(false);
          }}
          isFluxoVinculoAutomatico={isFluxoVinculoAutomaticoDespesa}
          setIsFluxoVinculoAutomatico={setIsFluxoVinculoAutomaticoDespesa}
        />
      )}

      {despesaDetalhada && showModalCadastrarDespesa && (
        <ModalCadastrarDespesaUnicaGroupPay
          despesaDetalhada={despesaDetalhada}
          showModal={showModalCadastrarDespesa}
          onCloseModal={() => {
            setShowModalCadastrarDespesa(false);
            setDespesaDetalhada(null);
          }}
        />
      )}

      {despesaDetalhada && showModalInformarParcelas && (
        <ModalInformarParcelasGroupPay
          showModal={showModalInformarParcelas}
          onCloseModal={() => setShowModalInformarParcelas(!showModalInformarParcelas)}
          valorTotalParcelas={despesaDetalhada?.valor}
          openModalCadastrarDepesaParcelada={handleAbrirCadastroParcelada}
          numeroParcelasPadrao={numeroParcelasPadrao}
          dataVencimentoPrimeiraParcelaPadrao={
            isDespesaAgrupada && despesaAgrupada && despesaAgrupada.despesasOriginais.length > 0
              ? despesaAgrupada.despesasOriginais[0].dataVencimento != null
                ? new Date(despesaAgrupada.despesasOriginais[0].dataVencimento)
                : despesaAgrupada.despesasOriginais[0].dataEmissao
                  ? new Date(despesaAgrupada.despesasOriginais[0].dataEmissao)
                  : undefined
              : ehCarneParcelado && parcelasDoCarne[0]?.dataVencimento
                ? new Date(parcelasDoCarne[0].dataVencimento)
                : despesaDetalhada?.dataVencimento
                  ? new Date(despesaDetalhada.dataVencimento)
                  : undefined
          }
        />
      )}

      {despesaDetalhada && dadosParcelamento && showModalCadastrarDespesaParcelada && (
        <ModalCadastrarDespesaParceladaGroupPay
          showModal={showModalCadastrarDespesaParcelada}
          onCloseModal={() => {
            setShowModalCadastrarDespesaParcelada(false);
            setDadosParcelamento(null);
          }}
          despesaGroupPay={despesaDetalhada}
          parcelas={dadosParcelamento.parcelas}
          valorTotalParcelas={
            dadosParcelamento.parcelas?.reduce((soma, parcela) => soma + (parcela.valorParcela || 0), 0) ||
            dadosParcelamento.valorTotal
          }
          condominioId={despesaDetalhada.idCondominio}
          idsDespesasAgrupadas={isDespesaAgrupada && despesaAgrupada ? despesaAgrupada.ids : undefined}
        />
      )}
    </>
  );
};

export default ItemListaDespesaGroupPay;
